<template>
	<page-content bgClass="bg-#0E0E0E" :disablePullRefresh="true">
		<template v-slot:navBar>
			<home-nav :isHome="true" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div style="padding-bottom: 20px;">
				<!-- 顶部右侧操作按钮：添加流动性 -->
					<div class="top-actions">
						<button class="btn-liquidity" @click="goToAddLp">{{ $t("添加流动性") }}</button>
					</div>
				<div class="daiview">
					<div class="daione">
						<span class="jiaoname">{{$t("交换代币")}}</span>
                        <div style="margin-left: auto; display: flex; align-items: center;">
						    <img src="@/assets/images/new/icon_sj.png" @click="zoushipop=!zoushipop" class="icon_sz" alt="" style="margin-left: 0; margin-right: 10px;">
						    <img src="@/assets/images/new/icon_sz.png" @click="ishua=!ishua" class="icon_sz" alt="" style="margin-left: 0;">
                        </div>
					</div>
					<div class="huaview" v-if="ishua">
						<span class="huaname">{{$t("滑点容差")}}</span>
						<div class="huaright">
							<div class="huaitem " :class="shuzhi==1?'hactive':''" @click="getshuzhi(1)">0.1%</div>
							<div class="huaitem" :class="shuzhi==2?'hactive':''" @click="getshuzhi(2)">0.5%</div>
							<div class="huaitem" :class="shuzhi==3?'hactive':''" @click="getshuzhi(3)">1%</div>
						</div>
					</div>
					<div class="cong">
						<span class="congname">{{$t("从")}}</span>
						<span class="yue">{{$t("余额")}} {{from.balance}}</span>
					</div>
					<div class="jiaoone">
						<div class="jiaohead">
                            <input class="jiaoshu" v-model="num" @input="handleInputFrom" type="text" :placeholder="shuru" />
							<div class="jhrig" @click="selectSelectpop(1)">
								<img :src="from.logo" class="icon_yth" alt="">
								<span class="jrname">{{from.name}}</span>
								<img src="@/assets/images/new/icon_qh.png" class="icon_qh" alt="">
							</div>
						</div>
<!--						<span class="yudeng">≈$0.00</span>-->
					</div>
                    <img src="@/assets/images/new/jiao.png" class="jiaoimg" alt="" @click="swapFromTo">
					<div class="cong ctwo">
						<span class="congname">{{$t("至")}}</span>
						<span class="yue">{{$t("余额")}}  {{to.balance}}</span>
					</div>
					<div class="jiaoone">
						<div class="jiaohead">
                            <input class="jiaoshu" :value="calculatedOut" type="text" :placeholder="shuru" readonly />

							<div class="jhrig" @click="selectSelectpop(2)">
								<img :src="to.logo" class="icon_yth" alt="">
								<span class="jrname">{{to.name}}</span>
								<img src="@/assets/images/new/icon_qh.png" class="icon_qh" alt="">
							</div>
						</div>
<!--						<span class="yudeng">≈$0.00</span>-->
					</div>
					<div class="feiview" >
<!--					<div class="feiview" @click="zoushipop = true">-->
					<div class="feiitem">
						<span class="feileft">{{$t("费率")}}</span>
						<span class="feirig">{{ feeRateText }}</span>
					</div>
					<div class="feiitem">
						<span class="feileft">{{$t("滑动")}}</span>
						<span class="feirig bai">{{ slippageText }}</span>
					</div>
					<div class="feiitem">
						<span class="feileft">{{$t("网络费用")}}</span>
						<span class="feirig">{{ networkFeeText }}</span>
					</div>
					</div>
                    <div class="jdai" @click="getpop" :style="{ pointerEvents: swapButtonDisabled ? 'none' : 'auto', opacity: swapButtonDisabled ? 0.6 : 1 }">{{ swapButtonText }}</div>
				</div>
                <div class="daiview daiviewtwo">
                    <div class="daione">
                        <span class="jiaoname">{{$t("最近的交换")}}</span>
                    </div>
                    <div v-if="swapHistory && swapHistory.length">
                        <div class="jilist" v-for="(item, index) in swapHistory" :key="item.txHash || index">
                            <img :src="item.fromLogo" class="icon_ythicon" alt="">
                            <img src="@/assets/images/new/jiaohuan.png" class="jiaohuan" alt="">
                            <img :src="item.toLogo" class="icon_ythicon" alt="">
                            <div class="jinav">
                                <span class="jinavname ellipsis">{{ item.amountIn }} {{ item.fromSymbol }} {{$t("兑换")}} {{ item.amountOut }} {{ item.toSymbol }}</span>
                                <span class="jinavtime">{{ item.timeAgo }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-else class="jilist">
                        <div class="jinav">
                            <span class="jinavname ellipsis">{{$t("暂无交换记录")}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
		<template v-slot:menuBar>
		</template>
		<template v-slot:popup>
			<van-popup v-model="selectpop" position="bottom" @close="selectpop=false">
				<div class="jiepopview">
					<div class="jieone">
						<span class="xname">{{$t("选择币种")}}</span>
						<img src="@/assets/images/new/icon_gb.png" @click="selectpop=false" class="icon_gb" alt="">
					</div>

<!--					<div class="jipoplist" :class="popbizhong==1?'jipopactive':''">-->
<!--						<img src="@/assets/images/new/nicon1.png" class="niconpop" alt="">-->
<!--						<div class="dpopright">-->
<!--							<div class="dpopone">-->
<!--								<span class="popname">{{$t("以太坊")}}</span>-->
<!--								<span class="popname ml">2.5</span>-->
<!--							</div>-->
<!--							<div class="dpopone mt-two">-->
<!--								<span class="popnametwo">Tether</span>-->
<!--								<span class="popnametwo ml">$2,456.78</span>-->
<!--							</div>-->
<!--						</div>-->
<!--					</div>-->


					<div class="jipoplist" v-for="(item, index) in trading_pair" :key="index" @click="selectPair(item)">
						<img :src="item.logo" class="niconpop" alt="">
						<div class="dpopright">
							<div class="dpopone">
								<span class="popname">{{item.name}}</span>
<!--								<span class="popname ml">850.50</span>-->
							</div>
							<div class="dpopone mt-two">
								<span class="popnametwo">Roon</span>
								<span class="popnametwo ml">{{ item.contract_address ? item.contract_address.slice(0,6)+'...'+item.contract_address.slice(-4) : '' }}</span>
							</div>
						</div>
					</div>

				</div>

			</van-popup>

			<!-- 走势弹窗 -->
            <van-popup v-model="zoushipop" position="bottom" @close="zoushipop=false" @opened="onChartPopupOpened" :lock-scroll="false">
                <div class="jiepopviewtwo">
                    <div class="zounewpop">
                        <div class="zsone">
<!--                            <div class="zstu">-->
<!--                                <img src="@/assets/images/new/nicon1.png" class="zouicon" alt="">-->
<!--								<img src="@/assets/images/new/nicon2.png" class="zouicon zouicontwo" alt="">-->
<!--							</div>-->
							<span class="zoutit">{{ tickerData.symbol || '' }}</span>
<!--							<img src="@/assets/images/new/qieicon.png" class="qieicon" alt="">-->
<!--							<img src="@/assets/images/new/icon_gb.png" @click="zoushipop=false" class="icon_gb" alt="">-->
						</div>
						<div style="display: flex; justify-content: space-between; align-items: center; margin: 10px 0 15px;">
							<span class="zounum" :style="{ color: tickerData.change >= 0 ? '#00bfa5' : '#ff3333', margin: '0' }">{{ formatTickerPrice(tickerData.price) }}</span>
							<img src="@/assets/images/new/icon_gb.png" @click="zoushipop=false" class="icon_gb" alt="" style="width: 20px; height: 20px; margin-right: 15px; position: relative; z-index: 9999; cursor: pointer; top: 0;">
						</div>
						<div class="zoutimes">
							<div class="zounewtem onitem">
								<span class="zhname">24H Change</span>
								<span class="zhshu" :class="{ lv: tickerData.change >= 0 }" :style="{ color: tickerData.change < 0 ? '#ff3333' : '' }">{{ tickerData.change > 0 ? '+' : ''}}{{ tickerData.change }}%</span>
							</div>
							<div class="zounewtem">
								<span class="zhname">24H High</span>
								<span class="zhshu">{{ formatTickerPrice(tickerData.high) }}</span>
							</div>
							<div class="zounewtem threeitem">
								<span class="zhname">24H Low</span>
								<span class="zhshu">{{ formatTickerPrice(tickerData.low) }}</span>
							</div>
						</div>
					</div>
                    <div class="shu"></div>
                    <div class="kxian" v-if="zoushipop">
                        <div class="tf-switch">
                            <span
                              v-for="it in intervalOptions"
                              :key="it"
                              class="tf-item"
                              :class="{ active: klineInterval === it }"
                              @click="changeKlineInterval(it)"
                            >{{ it }}</span>
                        </div>
                        <div class="echart" id="mychart" style="width:100%; height: 420px;"></div>
                    </div>
                </div>
            </van-popup>
		</template>
	</page-content>
</template>

<script>
	import homeNav from '@/components/home-nav/home-nav.vue';
	import * as echarts from 'echarts';
    // axios 可选；若不可用则使用 fetch
    import Web3 from "web3";
    import {getShowAddress, getToken, setShowAddress, setToken} from "@/libs/util";
    import { ajaxData } from '@/request/ajax.js'
    import utils from "@/utils/utils";
	const colorList = ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
	const labelFont = 'bold 12px Sans-serif';
    // 将任意十进制字符串格式化为固定小数位（截断并补零）
    function formatToFixed(decStr, digits = 6) {
        try {
            if (typeof decStr !== 'string') decStr = String(decStr || '0');
            if (!decStr || decStr === '0') return `0.${'0'.repeat(digits)}`;
            let negative = false;
            if (decStr[0] === '-') {
                negative = true;
                decStr = decStr.slice(1);
            }
            const parts = decStr.split('.');
            let intPart = parts[0] || '0';
            let fracPart = parts[1] || '';
            if (fracPart.length > digits) {
                fracPart = fracPart.slice(0, digits);
            } else {
                fracPart = fracPart.padEnd(digits, '0');
            }
            const result = `${intPart}.${fracPart}`;
            return negative ? `-${result}` : result;
        } catch (e) {
            return `0.${'0'.repeat(digits)}`;
        }
    }
    const ERC20_ABI = [
        {
            inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
            name: 'balanceOf',
            outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [],
            name: 'decimals',
            outputs: [{ internalType: 'uint8', name: '', type: 'uint8' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [],
            name: 'symbol',
            outputs: [{ internalType: 'string', name: '', type: 'string' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [
                { internalType: 'address', name: 'owner', type: 'address' },
                { internalType: 'address', name: 'spender', type: 'address' }
            ],
            name: 'allowance',
            outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [
                { internalType: 'address', name: 'spender', type: 'address' },
                { internalType: 'uint256', name: 'amount', type: 'uint256' }
            ],
            name: 'approve',
            outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
            stateMutability: 'nonpayable',
            type: 'function'
        }
    ];
    const ROUTER_ABI = [
        {
            inputs: [],
            name: 'WETH',
            outputs: [{ internalType: 'address', name: '', type: 'address' }],
            stateMutability: 'pure',
            type: 'function'
        },
        {
            inputs: [
                { internalType: 'uint256', name: 'amountIn', type: 'uint256' },
                { internalType: 'address[]', name: 'path', type: 'address[]' }
            ],
            name: 'getAmountsOut',
            outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [
                { internalType: 'uint256', name: 'amountIn', type: 'uint256' },
                { internalType: 'uint256', name: 'amountOutMin', type: 'uint256' },
                { internalType: 'address[]', name: 'path', type: 'address[]' },
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'uint256', name: 'deadline', type: 'uint256' }
            ],
            name: 'swapExactTokensForTokens',
            outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
            stateMutability: 'nonpayable',
            type: 'function'
        },
        {
            inputs: [
                { internalType: 'uint256', name: 'amountOutMin', type: 'uint256' },
                { internalType: 'address[]', name: 'path', type: 'address[]' },
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'uint256', name: 'deadline', type: 'uint256' }
            ],
            name: 'swapExactETHForTokens',
            outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
            stateMutability: 'payable',
            type: 'function'
        },
        {
            inputs: [
                { internalType: 'uint256', name: 'amountIn', type: 'uint256' },
                { internalType: 'uint256', name: 'amountOutMin', type: 'uint256' },
                { internalType: 'address[]', name: 'path', type: 'address[]' },
                { internalType: 'address', name: 'to', type: 'address' },
                { internalType: 'uint256', name: 'deadline', type: 'uint256' }
            ],
            name: 'swapExactTokensForETH',
            outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
            stateMutability: 'nonpayable',
            type: 'function'
        }
    ];
    // Minimal WETH ABI for wrap/unwrap
    const WETH_ABI = [
        {
            inputs: [],
            name: 'deposit',
            outputs: [],
            stateMutability: 'payable',
            type: 'function'
        },
        {
            inputs: [ { internalType: 'uint256', name: 'wad', type: 'uint256' } ],
            name: 'withdraw',
            outputs: [],
            stateMutability: 'nonpayable',
            type: 'function'
        }
    ];
    // Minimal Factory ABI for pair lookup
    const FACTORY_ABI = [
        {
            inputs: [
                { internalType: 'address', name: 'tokenA', type: 'address' },
                { internalType: 'address', name: 'tokenB', type: 'address' }
            ],
            name: 'getPair',
            outputs: [{ internalType: 'address', name: '', type: 'address' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [],
            name: 'allPairsLength',
            outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [{ internalType: 'uint256', name: 'index', type: 'uint256' }],
            name: 'allPairs',
            outputs: [{ internalType: 'address', name: '', type: 'address' }],
            stateMutability: 'view',
            type: 'function'
        }
    ];
    // Minimal Pair ABI for reading tokens and Swap events
    const PAIR_ABI = [
        {
            inputs: [],
            name: 'token0',
            outputs: [{ internalType: 'address', name: '', type: 'address' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            inputs: [],
            name: 'token1',
            outputs: [{ internalType: 'address', name: '', type: 'address' }],
            stateMutability: 'view',
            type: 'function'
        },
        {
            anonymous: false,
            inputs: [
                { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
                { indexed: false, internalType: 'uint256', name: 'amount0In', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1In', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount0Out', type: 'uint256' },
                { indexed: false, internalType: 'uint256', name: 'amount1Out', type: 'uint256' },
                { indexed: true, internalType: 'address', name: 'to', type: 'address' }
            ],
            name: 'Swap',
            type: 'event'
        }
    ];
	function calculateMA(dayCount, data) {
		let result = [];
		for (let i = 0, len = data.length; i < len; i++) {
			if (i < dayCount) {
				result.push('-');
				continue;
			}
			let sum = 0;
			for (let j = 0; j < dayCount; j++) {
				sum += +data[i - j][1];
			}
			result.push((sum / dayCount).toFixed(2));
		}
		return result;
	}
	// prettier-ignore
	const dates = ["2016-03-29", "2016-03-30", "2016-03-31", "2016-04-01", "2016-04-04", "2016-04-05", "2016-04-06", "2016-04-07", "2016-04-08", "2016-04-11", "2016-04-12", "2016-04-13", "2016-04-14", "2016-04-15", "2016-04-18", "2016-04-19", "2016-04-20", "2016-04-21", "2016-04-22", "2016-04-25", "2016-04-26", "2016-04-27", "2016-04-28", "2016-04-29", "2016-05-02", "2016-05-03", "2016-05-04", "2016-05-05", "2016-05-06", "2016-05-09", "2016-05-10", "2016-05-11", "2016-05-12", "2016-05-13", "2016-05-16", "2016-05-17", "2016-05-18", "2016-05-19", "2016-05-20", "2016-05-23", "2016-05-24", "2016-05-25", "2016-05-26", "2016-05-27", "2016-05-31", "2016-06-01", "2016-06-02", "2016-06-03", "2016-06-06", "2016-06-07", "2016-06-08", "2016-06-09", "2016-06-10", "2016-06-13", "2016-06-14", "2016-06-15", "2016-06-16", "2016-06-17", "2016-06-20", "2016-06-21", "2016-06-22"];
	// prettier-ignore
	const data = [[17512.58, 17633.11, 17434.27, 17642.81, 86160000], [17652.36, 17716.66, 17652.36, 17790.11, 79330000], [17716.05, 17685.09, 17669.72, 17755.7, 102600000], [17661.74, 17792.75, 17568.02, 17811.48, 104890000], [17799.39, 17737, 17710.67, 17806.38, 85230000], [17718.03, 17603.32, 17579.56, 17718.03, 115230000], [17605.45, 17716.05, 17542.54, 17723.55, 99410000], [17687.28, 17541.96, 17484.23, 17687.28, 90120000], [17555.39, 17576.96, 17528.16, 17694.51, 79990000], [17586.48, 17556.41, 17555.9, 17731.63, 107100000], [17571.34, 17721.25, 17553.57, 17744.43, 81020000], [17741.66, 17908.28, 17741.66, 17918.35, 91710000], [17912.25, 17926.43, 17885.44, 17962.14, 84510000], [17925.95, 17897.46, 17867.41, 17937.65, 118160000], [17890.2, 18004.16, 17848.22, 18009.53, 89390000], [18012.1, 18053.6, 17984.43, 18103.46, 89820000], [18059.49, 18096.27, 18031.21, 18167.63, 100210000], [18092.84, 17982.52, 17963.89, 18107.29, 102720000], [17985.05, 18003.75, 17909.89, 18026.85, 134120000], [17990.94, 17977.24, 17855.55, 17990.94, 83770000], [17987.38, 17990.32, 17934.17, 18043.77, 92570000], [17996.14, 18041.55, 17920.26, 18084.66, 109090000], [18023.88, 17830.76, 17796.55, 18035.73, 100920000], [17813.09, 17773.64, 17651.98, 17814.83, 136670000], [17783.78, 17891.16, 17773.71, 17912.35, 80100000], [17870.75, 17750.91, 17670.88, 17870.75, 97060000], [17735.02, 17651.26, 17609.01, 17738.06, 95020000], [17664.48, 17660.71, 17615.82, 17736.11, 81530000], [17650.3, 17740.63, 17580.38, 17744.54, 80020000], [17743.85, 17705.91, 17668.38, 17783.16, 85590000], [17726.66, 17928.35, 17726.66, 17934.61, 75790000], [17919.03, 17711.12, 17711.05, 17919.03, 87390000], [17711.12, 17720.5, 17625.38, 17798.19, 88560000], [17711.12, 17535.32, 17512.48, 17734.74, 86640000], [17531.76, 17710.71, 17531.76, 17755.8, 88440000], [17701.46, 17529.98, 17469.92, 17701.46, 103260000], [17501.28, 17526.62, 17418.21, 17636.22, 79120000], [17514.16, 17435.4, 17331.07, 17514.16, 95530000], [17437.32, 17500.94, 17437.32, 17571.75, 111990000], [17507.04, 17492.93, 17480.05, 17550.7, 87790000], [17525.19, 17706.05, 17525.19, 17742.59, 86480000], [17735.09, 17851.51, 17735.09, 17891.71, 79180000], [17859.52, 17828.29, 17803.82, 17888.66, 68940000], [17826.85, 17873.22, 17824.73, 17873.22, 73190000], [17891.5, 17787.2, 17724.03, 17899.24, 147390000], [17754.55, 17789.67, 17664.79, 17809.18, 78530000], [17789.05, 17838.56, 17703.55, 17838.56, 75560000], [17799.8, 17807.06, 17689.68, 17833.17, 82270000], [17825.69, 17920.33, 17822.81, 17949.68, 71870000], [17936.22, 17938.28, 17936.22, 18003.23, 78750000], [17931.91, 18005.05, 17931.91, 18016, 71260000], [17969.98, 17985.19, 17915.88, 18005.22, 69690000], [17938.82, 17865.34, 17812.34, 17938.82, 90540000], [17830.5, 17732.48, 17731.35, 17893.28, 101690000], [17710.77, 17674.82, 17595.79, 17733.92, 93740000], [17703.65, 17640.17, 17629.01, 17762.96, 94130000], [17602.23, 17733.1, 17471.29, 17754.91, 91950000], [17733.44, 17675.16, 17602.78, 17733.44, 248680000], [17736.87, 17804.87, 17736.87, 17946.36, 99380000], [17827.33, 17829.73, 17799.8, 17877.84, 85130000], [17832.67, 17780.83, 17770.36, 17920.16, 89440000]];
	// prettier-ignore
	const volumes = [86160000, 79330000, 102600000, 104890000, 85230000, 115230000, 99410000, 90120000, 79990000, 107100000, 81020000, 91710000, 84510000, 118160000, 89390000, 89820000, 100210000, 102720000, 134120000, 83770000, 92570000, 109090000, 100920000, 136670000, 80100000, 97060000, 95020000, 81530000, 80020000, 85590000, 75790000, 87390000, 88560000, 86640000, 88440000, 103260000, 79120000, 95530000, 111990000, 87790000, 86480000, 79180000, 68940000, 73190000, 147390000, 78530000, 75560000, 82270000, 71870000, 78750000, 71260000, 69690000, 90540000, 101690000, 93740000, 94130000, 91950000, 248680000, 99380000, 85130000, 89440000];

	const dataMA5 = calculateMA(5, data);
	const dataMA10 = calculateMA(10, data);
	const dataMA20 = calculateMA(20, data);

	export default {
		components: {
			homeNav,
		},
		mounted() {

		},
		beforeDestroy() {
			// 组件销毁时释放图表实例，防止内存泄漏
			this.disposeKChart && this.disposeKChart();
		},
    data() {
        return {
            // ECharts K线图实例
            kChartInstance: null,
            // 时间粒度
            klineInterval: '1m',
            intervalOptions: ['1m','5m','30m','1d'],


				num:0.00,
				ishua:false,
                web3Provider: null,
                web3: null,
				shuzhi:1,
				selectpop:false,
				selectpop_type:1,
                FACTORY_ADDRESS:"0xf4516EFf9b8F046E86B64FD6956dce0928296856",
                ROUTER_ADDRESS:"0xa54d92bEd6455E43a09f6315fD050edFA9997306",
				popbizhong:1,
                from:{
                    "contract_address":"",
                    "id":1,
                    "name":"ROON",
                    "balance":"0",
                    "symbol":"ROON",
                    // 通过 webpack 的 require 在数据里引入静态图片资源
                    "logo": require('@/assets/images/common/img_logo.png'),
                },
                to:{
                    "contract_address":"0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
                    "id":3,
                    "name":"USDR",
                    "balance":"0",
                    "symbol":"USDR",
                    // 通过 webpack 的 require 在数据里引入静态图片资源
                    "logo": require('@/assets/images/common/usdr.png'),
                },
                trading_pair: [
                    {
                        "contract_address":"",
                        "id":1,
                        "name":"ROON",
                        "balance":"0",
                        "symbol":"ROON",
                        // 通过 webpack 的 require 在数据里引入静态图片资源
                        "logo": require('@/assets/images/common/img_logo.png'),
                    },
                    // {
                    //     "contract_address":"0x85CBe6769368C83C1f82f8f65118D5A34c2Bf62a",
                    //     "id":2,
                    //     "name":"WROON",
                    //     "balance":"0",
                    //     "symbol":"WROON",
                    //     // 通过 webpack 的 require 在数据里引入静态图片资源
                    //     "logo": require('@/assets/images/common/img_logo.png'),
                    // },
                    {
                        "contract_address":"0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
                        "id":3,
                        "name":"USDR",
                        "balance":"0",
                        "symbol":"USDR",
                        // 通过 webpack 的 require 在数据里引入静态图片资源
                        "logo": require('@/assets/images/common/usdr.png'),
                    }
                ],
                // 最新报价与网络费用
                feeRate: null,
                networkFee: null,
                // 兑换结果（至）展示值
                amountOut: '', // 实时单价（1 from = amountOut to）
                calculatedOut: '', // 根据 num * amountOut 计算的结果
                // 最近交换记录
                swapHistory: [],
				// 按钮状态：idle/authing/auth_success/auth_fail/swapping/swap_success/swap_fail
				buttonState:'idle',
            invite:'',
				zoushipop:false,
                tickerData: {
                    symbol: '',
                    price: '--',
                    change: 0,
                    high: '--',
                    low: '--'
                }
			};
		},
    watch: {
        // 弹窗开关时初始化或销毁图表，确保容器尺寸正确
        zoushipop(val) {
            if (!val) {
                this.disposeKChart();
            }
        },
			// 当输入金额变化时，自动刷新报价与兑换结果
			num(){
				this.updateQuoteAndFees && this.updateQuoteAndFees().catch(e => console.error('updateQuoteAndFees on amount input error', e))
			}
		},
		computed: {
			shuru(){
				return this.$t("请输入")
			},
            // 费率展示：1 from = X to
            feeRateText(){
                const vm = this
                if (!vm.feeRate) return vm.$t('暂无报价')
                const fromName = vm.from && vm.from.name ? vm.from.name : vm.$t('主币')
                const toName = vm.to && vm.to.name ? vm.to.name : vm.$t('代币')
                return `1${fromName} = ${vm.feeRate} ${toName}`
            },
            // 滑点展示
            slippageText(){
                const s = this.shuzhi
                // 将选择映射到百分比
                const map = { 1: '0.1', 2: '0.5', 3: '1.0' }
                const pct = map[s] || '0.5'
                return `${pct}%`
            },
            // 网络费用展示（主币）
            networkFeeText(){
                const vm = this
                if (!vm.networkFee) return '≈ ~'
                // 这里以主币符号 ROON 展示；若你有具体符号可替换
                return `≈ ${vm.networkFee} ROON`
            },
			swapButtonText(){
				const vm = this
				switch(vm.buttonState){
					case 'authing': return '正在授权'
					case 'auth_success': return '授权成功'
					case 'auth_fail': return '授权失败'
					case 'swapping': return '正在兑换'
					case 'swap_success': return '兑换成功'
					case 'swap_fail': return '兑换失败'
					default: return vm.$t('交换代币')
				}
			},
			swapButtonDisabled(){
				return this.buttonState === 'authing' || this.buttonState === 'swapping'
			},
		},
		created() {
            let vm = this
            if (window.ethereum) {
                vm.web3Provider = window.ethereum
                vm.web3 = new Web3(vm.web3Provider);

                vm.enable()
            }
            getShowAddress()
            vm.refreshBalances()
            vm.updateQuoteAndFees && vm.updateQuoteAndFees().catch(e => console.error('updateQuoteAndFees init error', e))
            // 加载最近交换记录（当前选择的交易对，近若干块）
            vm.fetchRecentSwaps && vm.fetchRecentSwaps().catch(e => console.error('fetchRecentSwaps init error', e))
		},
    methods: {
        enable() {
            let vm = this
            vm.web3Provider.enable() //如果用户拒绝了登录请求
                .catch(function(reason) {
                    console.log("reason")
                    if (reason === 'User rejected provider access') {
                        vm.$message.error(utils.$t("吐司.用户拒绝提供程序访问"))
                    } else {
                        // 本不该执行到这里，但是真到这里了，说明发生了意外
                        vm.$message.error(utils.$t("吐司.请刷新重试"))
                    }
                })
                //如果用户同意了登录请求，你就可以拿到用户的账号
                .then(function(accounts) {
                    console.log("-----")
                    // alert(ethereum.selectedAddress)
                    // You also should verify the user is on the correct network:
                    //你也可以验证用户接入了正确的网络
                    if (vm.web3Provider.networkVersion !== vm.desiredNetwork) {
                        // layer_msg('请选择正确的网络.')
                        //我们计划在最近补充一个有关网络切换的API，参考下面链接
                        // https://github.com/MetaMask/metamask-extension/issues/3663
                    }
                    //一旦获取了用户账号，你就可以签名交易
                    console.log(accounts)

                    vm.address = vm.web3Provider.selectedAddress

                    vm.address = vm.address.toLowerCase()

                    console.log("selectaddress:" + vm.address)
                    let token = getToken()
                    // setToken("")
                    // token = false
                    if (token == false) {
                        vm.web3.eth.personal.sign(vm.web3.utils.utf8ToHex("login"), vm.address, (err, sign) => {
                            if (err) {
                                vm.$message.error(err);
                            } else {
                                console.log(vm.address)

                                ajaxData("/register", {
                                    address: sign,
                                    invite: vm.invite,
                                }).then(response => {
                                    console.log(response)
                                    setToken(response.data.token)
                                    vm.getUserInfo()
                                    // vm.getIndex()
                                })
                                // }else {
                                //     vm.getIndex()
                                // }

                            }
                        })
                    } else {
                        vm.getUserInfo()
                    }
                })
        },
        getUserInfo() {
            let vm = this

            ajaxData("/user/info", {}).then(response => {

                vm.show_address = response.data.show_address

                setShowAddress(response.data.show_address)
                getShowAddress()
                if (response.data.address != vm.address) {
                    setToken("")
                    vm.enable()
                }

            })
        },
        formatTickerPrice(val) {
            if (val === '--' || val === null || val === undefined) return val;
            const num = Number(val);
            if (isNaN(num)) return val;
            // 格式化为6位小数，并去除多余的尾部0（可选），这里强制保留6位
            return num.toFixed(6);
        },
        formatTime(ts, interval) {
            const d = new Date(ts);
            const M = (d.getMonth() + 1).toString().padStart(2, '0');
            const D = d.getDate().toString().padStart(2, '0');
            const h = d.getHours().toString().padStart(2, '0');
            const m = d.getMinutes().toString().padStart(2, '0');
            // 如果是日线，只显示日期
            if (interval === '1d') {
                return `${M}-${D}`;
            }
            // 其它显示 日期+时间
            return `${M}-${D} ${h}:${m}`;
        },
        // 弹窗打开后初始化并渲染假数据K线
        onChartPopupOpened() {
            try {
                this.initKChart();
                // 初始化时按默认粒度加载数据
                this.loadKline(this.klineInterval);
                // 每次弹窗打开时，都请求 ticker 数据以刷新 24H 统计
                this.fetchTickerData();
            } catch (e) {
                const vm = this;
                if (vm.$message && vm.$message.error) {
                    vm.$message.error('K线初始化失败: ' + (e && e.message ? e.message : '未知错误'));
                } else {
                    console.error('K线初始化失败', e);
                }
            }
        },
        // 切换时间粒度
        changeKlineInterval(it){
            if (!it || it === this.klineInterval) return
            this.klineInterval = it
            this.loadKline(it)
        },
        // 加载后端 K线数据（使用 ajaxData 请求，符号来自当前 from/to）
        async loadKline(interval){
            const vm = this
            try{
                const fromSym = String(vm.from?.symbol || vm.from?.name || '').toUpperCase()
                const toSym   = String(vm.to?.symbol   || vm.to?.name   || '').toUpperCase()
                // 与后端约定使用连字符分隔的交易对符号，例如 USDR-ROON
                const symbolA = `${fromSym}-${toSym}`
                const symbolB = `${toSym}-${fromSym}`

                // 先尝试 from+to，不行再回退到 to+from
                async function fetchKline(sym){
                    try{
                        const res = await ajaxData('/kline', { symbol: sym, interval, limit: 500 })
                        const rows = Array.isArray(res?.data) ? res.data : []
                        return rows
                    }catch(err){
                        return []
                    }
                }

                // 仅请求当前方向的符号，不再回退到反向符号，避免混淆
                let rows = await fetchKline(symbolA)

                let times, kdata
                if (Array.isArray(rows) && rows.length > 0){
                    // 后端返回 Binance 兼容的行：
                    // [openTime, open, high, low, close, volume, closeTime, quoteAssetVolume, numberOfTrades, takerBuyBaseAssetVolume, takerBuyQuoteAssetVolume, ignore]
                    times = rows.map(r => vm.formatTime(Number(r[0]), interval)) // open time ms
                    kdata = rows.map(r => [ Number(r[1]), Number(r[4]), Number(r[3]), Number(r[2]) ])
                } else {
                    // 回退：生成本地模拟数据，保证图表可展示
                    const stepMs = (interval === '1m') ? 60*1000 : (interval === '5m') ? 5*60*1000 : (interval === '30m') ? 30*60*1000 : 24*60*60*1000
                    const n = 200
                    const now = Date.now()
                    times = Array.from({ length: n }, (_, i) => vm.formatTime(now - (n - i) * stepMs, interval))
                    let price = 2000
                    kdata = times.map(() => {
                        const o = price
                        const c = o + (Math.random() - 0.5) * 5
                        const h = Math.max(o, c) + Math.random() * 2
                        const l = Math.min(o, c) - Math.random() * 2
                        price = c
                        return [o, c, l, h]
                    })
                    console.warn('K线数据为空，已使用本地模拟数据展示')
                }
                // r: [openTime, open, high, low, close, ...]
                // 我们的顺序：[open, close, low, high]
                if (!vm.kChartInstance) {
                    // 保证图表实例已初始化
                    vm.initKChart()
                }

                const option = vm.kChartInstance && vm.kChartInstance.getOption ? vm.kChartInstance.getOption() : {}
                const startValue = Math.max(0, times.length - 120)
                const endValue = times.length > 0 ? times.length - 1 : 0
                const update = {
                    xAxis: [{ data: times }],
                    dataZoom: [
                        { startValue, endValue },
                        { startValue, endValue }
                    ],
                    series: [
                        { type: 'candlestick', name: 'K线', data: kdata },
                        { type: 'line', name: 'MA5', data: calculateMA(kdata, 5) },
                        { type: 'line', name: 'MA10', data: calculateMA(kdata, 10) },
                        { type: 'line', name: 'MA20', data: calculateMA(kdata, 20) }
                    ]
                }
                // 使用合并更新，避免覆盖掉必须的坐标轴/组件配置导致内部读取错误
                vm.kChartInstance.setOption(update, false)

                // 总是使用当前K线数据的最新收盘价更新价格（保证实时性）
                // if (Array.isArray(rows) && rows.length > 0) {
                //     const latest = rows[rows.length - 1]
                //     vm.tickerData.price = Number(latest[4])
                // }

                // 如果当前加载的是日线数据，直接更新完整统计（High/Low/Change）
                if (interval === '1d' && Array.isArray(rows) && rows.length > 0) {
                    vm.updateTickerFromRows(rows)
                } else {
                    // 非日线模式：不再在此处请求 fetchTickerData，因为 onChartPopupOpened 已经统一调用
                }
            }catch(e){
                console.error('loadKline error', e)
                vm.$message && vm.$message.error('加载K线失败，请稍后重试')
            }
            // 计算移动平均线（收盘价）
            function calculateMA(kdata, dayCount){
                const result = []
                for (let i = 0; i < kdata.length; i++) {
                    if (i < dayCount - 1) { result.push('-'); continue }
                    let sum = 0
                    for (let j = 0; j < dayCount; j++) sum += Number(kdata[i - j][1])
                    result.push(sum / dayCount)
                }
                return result
            }
        },
        updateTickerFromRows(rows) {
            const vm = this
            if (!rows || rows.length === 0) return
            const r = rows[rows.length - 1]
            const open = Number(r[1])
            const high = Number(r[2])
            const low = Number(r[3])
            const close = Number(r[4])

            vm.tickerData.price = close
            vm.tickerData.high = high
            vm.tickerData.low = low

            const change = ((close - open) / open) * 100
            vm.tickerData.change = change.toFixed(2)

            const fromSym = String(vm.from?.symbol || vm.from?.name || '').toUpperCase()
            const toSym   = String(vm.to?.symbol   || vm.to?.name   || '').toUpperCase()
            vm.tickerData.symbol = `${fromSym}/${toSym}`
        },
        async fetchTickerData() {
            const vm = this;
            try {
                const fromSym = String(vm.from?.symbol || vm.from?.name || '').toUpperCase()
                const toSym   = String(vm.to?.symbol   || vm.to?.name   || '').toUpperCase()
                const symbol = `${fromSym}-${toSym}`

                vm.tickerData.symbol = `${fromSym}/${toSym}`

                // 使用新的 ticker 接口获取24H统计数据
                const res = await ajaxData('/kline/ticker', { symbol: symbol })
                const data = res?.data || {}

                vm.tickerData.price = Number(data.price)
                vm.tickerData.high = Number(data.high)
                vm.tickerData.low = Number(data.low)
                vm.tickerData.change = String(data.change)
            } catch (e) {
                console.error('fetchTickerData error', e)
            }
        },
        initKChart() {
            const vm = this;
            const el = document.getElementById('mychart');
            if (!el) {
                if (vm.$message && vm.$message.error) vm.$message.error('找不到图表容器 mychart');
                return;
            }
            // 先释放旧实例，避免重复初始化
            if (vm.kChartInstance) {
                try { vm.kChartInstance.dispose(); } catch (e) {}
                vm.kChartInstance = null;
            }
            vm.kChartInstance = echarts.init(el);

            // 颜色配置（参考薄饼风格：涨为绿，跌为红）
            const upColor = '#26a69a';
            const downColor = '#ef5350';

            // 初始空数据，由 loadKline 填充
            const times = []
            const kdata = []
            const startValue = 0
            const endValue = 0

            const option = {
                backgroundColor: '#0E0E0E',
                animation: false,
                legend: { top: 6, left: 60, textStyle: { color: '#ddd' } },
                tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
                axisPointer: { link: [{ xAxisIndex: [0] }] },
                grid: [
                    { left: 40, right: 20, top: 30, bottom: 35, containLabel: true }   // 仅保留K线主图
                ],
                xAxis: [
                    { type: 'category', data: times, boundaryGap: true, axisLine: { lineStyle: { color: '#999' } }, axisLabel: { color: '#ddd' } }
                ],
                yAxis: [
                    { scale: true, axisLine: { lineStyle: { color: '#999' } }, axisLabel: { color: '#ddd' }, splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } } }
                ],
                dataZoom: [
                    {
                        type: 'inside', xAxisIndex: [0], filterMode: 'filter',
                        moveOnMouseMove: true, moveOnMouseWheel: true, zoomOnMouseWheel: true,
                        startValue, endValue
                    },
                    {
                        type: 'slider', xAxisIndex: [0], filterMode: 'filter',
                        bottom: 8, height: 22,
                        startValue, endValue,
                        handleSize: 15,
                        handleStyle: { color: '#888' }
                    }
                ],
                series: [
                    {
                        type: 'candlestick', name: 'K线', data: kdata,
                        itemStyle: { color: upColor, color0: downColor, borderColor: upColor, borderColor0: downColor }
                    },
                    { type: 'line', name: 'MA5', data: [], smooth: true, showSymbol: false, lineStyle: { color: '#ffd54f', width: 1 } },
                    { type: 'line', name: 'MA10', data: [], smooth: true, showSymbol: false, lineStyle: { color: '#42a5f5', width: 1 } },
                    { type: 'line', name: 'MA20', data: [], smooth: true, showSymbol: false, lineStyle: { color: '#ab47bc', width: 1 } }
                ]
            };
            vm.kChartInstance.setOption(option);

            // 绑定resize，处理弹窗动画初始宽度为0的问题
            window.addEventListener('resize', vm.handleChartResize);
            setTimeout(() => vm.handleChartResize(), 150);
        },
        handleChartResize() {
            if (this.kChartInstance) {
                try { this.kChartInstance.resize(); } catch (e) {}
            }
        },
        disposeKChart() {
            const vm = this;
            window.removeEventListener('resize', vm.handleChartResize);
            if (vm.kChartInstance) {
                try { vm.kChartInstance.dispose(); } catch (e) {}
                vm.kChartInstance = null;
            }
        },
            // 监听“从”侧输入，规范化数字并刷新报价
            handleInputFrom(e){
                const raw = (e && e.target && e.target.value) || ''
                // 仅保留数字和一个小数点
                let v = String(raw).replace(/[^\d.]/g, '')
                // 不允许以点开头
                if (v.startsWith('.')) v = ''
                // 只保留一个小数点
                const parts = v.split('.')
                if (parts.length > 2) v = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '')
                // 去除不必要的前导零：默认为 0 时，直接输入 1 应变为 1 而非 01
                if (v.includes('.')) {
                    const endsWithDot = v.endsWith('.')
                    const [intPart, fracPartRaw] = v.split('.')
                    let intPartNorm = intPart.replace(/^0+(?=\d)/, '')
                    if (intPartNorm === '') intPartNorm = '0'
                    const fracPart = (endsWithDot ? '' : (fracPartRaw || ''))
                    v = intPartNorm + (endsWithDot ? '.' : (fracPart ? '.' + fracPart : ''))
                } else {
                    v = v.replace(/^0+(?=\d)/, '')
                    if (v === '') v = '0'
                }
                this.num = v
                this.updateQuoteAndFees && this.updateQuoteAndFees().catch(err => console.error('updateQuoteAndFees on input error', err))
            },
            // 切换交易方向（from/to），并刷新报价与余额
            async swapFromTo(){
                const vm = this
                try{
                    const tmp = vm.from
                    vm.from = vm.to
                    vm.to = tmp
                    await vm.refreshBalances()
                    vm.updateQuoteAndFees && vm.updateQuoteAndFees().catch(err => console.error('updateQuoteAndFees after swap error', err))
                }catch(e){
                    console.error('swapFromTo error', e)
                }
            },
            // 将时间戳转换为“X分钟前/小时前/天前”
            formatTimeAgo(tsSec){
                try{
                    const vm = this
                    const now = Math.floor(Date.now()/1000)
                    const diff = Math.max(0, now - Number(tsSec || 0))
                    const mins = Math.floor(diff/60)
                    const hours = Math.floor(diff/3600)
                    const days = Math.floor(diff/86400)
                    if (diff < 60) return `1${vm.$t('分钟前')}`
                    if (mins < 60) return `${mins}${vm.$t('分钟前')}`
                    if (hours < 24) return `${hours}${vm.$t('小时前')}`
                    return `${days}${vm.$t('天前')}`
                }catch(_){ return ' ~ ' }
            },
            // 获取全链最近的交换记录（不跟随选择交易对，聚合所有交易对，取最近 limit 条）
            async fetchRecentSwaps(limit = 10){
                const vm = this
                try{
                    vm.swapHistoryLoading = true
                    if (!vm.web3) {
                        if (window.ethereum) {
                            vm.web3Provider = window.ethereum
                            vm.web3 = new Web3(vm.web3Provider)
                        } else {
                            throw new Error('No web3 provider')
                        }
                    }
                    if (!vm.FACTORY_ADDRESS) { vm.swapHistory = []; return }

                    const factory = new vm.web3.eth.Contract(FACTORY_ABI, vm.FACTORY_ADDRESS)
                    const router = new vm.web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)
                    let WETH = null
                    try { WETH = await router.methods.WETH().call() } catch (_) { WETH = null }

                    const latest = await vm.web3.eth.getBlockNumber()
                    const primarySpan = 9000
                    const fromBlock = Math.max(latest - primarySpan, 0)

                    // 枚举最近的若干交易对，提高性能（例如最多100个）
                    let totalPairs = 0
                    try { totalPairs = Number(await factory.methods.allPairsLength().call()) } catch(_){ totalPairs = 0 }
                    if (!totalPairs) { vm.swapHistory = []; return }
                    // 扩大枚举交易对数量（最多1000个），并在找到足够记录后提前停止
                    const scanCount = Math.min(totalPairs, 1000)
                    const startIndex = Math.max(totalPairs - scanCount, 0)

                    const tokenMetaCache = new Map() // address -> {symbol, decimals, logo}
                    const loadTokenMeta = async (addr) => {
                        const key = String(addr || '').toLowerCase()
                        if (!addr) return { symbol: 'UNKNOWN', decimals: 18, logo: '' }
                        if (tokenMetaCache.has(key)) return tokenMetaCache.get(key)
                        // 先尝试从本地 trading_pair 中匹配元数据
                        const local = (vm.trading_pair || []).find(x => String(x.contract_address || '').toLowerCase() === key)
                        const nativeEntry = (vm.trading_pair || []).find(x => !x.contract_address)
                        const nativeSymbol = 'ROON'
                        let symbol = local?.name || local?.symbol || ''
                        let logo = local?.logo || ''
                        let decimals = 18
                        // 若该地址为 WETH/WROON，则显示为主币符号 ROON
                        const isWETH = WETH && addr && String(addr).toLowerCase() === String(WETH).toLowerCase()
                        if (isWETH) {
                            symbol = nativeSymbol
                            decimals = 18
                            logo = nativeEntry?.logo || logo || ''
                        }
                        try {
                            const erc = new vm.web3.eth.Contract(ERC20_ABI, addr)
                            const [sym, dec] = await Promise.all([
                                erc.methods.symbol().call().catch(() => symbol || ''),
                                erc.methods.decimals().call().catch(() => 18)
                            ])
                            // WETH 仍强制显示为主币符号
                            symbol = isWETH ? nativeSymbol : (sym || symbol || (addr.slice(0,6)+'...'+addr.slice(-4)))
                            decimals = isWETH ? 18 : Number(dec || 18)
                        } catch(_) {
                            symbol = isWETH ? nativeSymbol : (symbol || (addr.slice(0,6)+'...'+addr.slice(-4)))
                            decimals = 18
                        }
                        const meta = { symbol, decimals, logo }
                        tokenMetaCache.set(key, meta)
                        return meta
                    }

                    const toDecimalString = (bn, decimals) => {
                        const s = vm.web3.utils.toBN(bn || '0').toString()
                        const d = Number(decimals)
                        if (d === 0) return s
                        if (s.length <= d) return `0.${'0'.repeat(d - s.length)}${s}`
                        return `${s.slice(0, s.length - d)}.${s.slice(s.length - d)}`
                    }

                    const allEvents = []
                    for (let i = totalPairs - 1; i >= startIndex; i--) {
                        let pairAddr = null
                        try { pairAddr = await factory.methods.allPairs(i).call() } catch(_){ pairAddr = null }
                        if (!pairAddr) continue
                        const pair = new vm.web3.eth.Contract(PAIR_ABI, pairAddr)
                        let token0 = null, token1 = null
                        try {
                            token0 = await pair.methods.token0().call()
                            token1 = await pair.methods.token1().call()
                        } catch(_) { token0 = null; token1 = null }
                        // 拉取最近区块的 Swap 事件（使用数值 toBlock，窗口小于 1 万）
                        let events = []
                        try{
                            events = await pair.getPastEvents('Swap', { fromBlock, toBlock: latest })
                        }catch(err){
                            // 某些对可能无事件或节点限制，忽略
                            continue
                        }
                        // 解析事件
                        const meta0 = await loadTokenMeta(token0)
                        const meta1 = await loadTokenMeta(token1)
                        for (const ev of events) {
                            const rv = ev.returnValues || {}
                            const amount0In = rv.amount0In || '0'
                            const amount1In = rv.amount1In || '0'
                            const amount0Out = rv.amount0Out || '0'
                            const amount1Out = rv.amount1Out || '0'

                            let fromSymbol = ''
                            let toSymbol = ''
                            let fromLogo = meta0.logo
                            let toLogo = meta1.logo
                            let amountInStr = '0'
                            let amountOutStr = '0'

                            if (vm.web3.utils.toBN(amount0Out).gt(vm.web3.utils.toBN('0'))) {
                                // 输出 token0，输入 token1
                                fromSymbol = meta1.symbol
                                toSymbol = meta0.symbol
                                // 修正方向：输入为 token1，输出为 token0
                                fromLogo = meta1.logo
                                toLogo = meta0.logo
                                amountInStr = toDecimalString(amount1In, meta1.decimals)
                                amountOutStr = toDecimalString(amount0Out, meta0.decimals)
                            } else {
                                // 输出 token1，输入 token0
                                fromSymbol = meta0.symbol
                                toSymbol = meta1.symbol
                                // 修正方向：输入为 token0，输出为 token1
                                fromLogo = meta0.logo
                                toLogo = meta1.logo
                                amountInStr = toDecimalString(amount0In, meta0.decimals)
                                amountOutStr = toDecimalString(amount1Out, meta1.decimals)
                            }

                            allEvents.push({
                                txHash: ev.transactionHash,
                                blockNumber: ev.blockNumber,
                                transactionIndex: ev.transactionIndex || 0,
                                logIndex: ev.logIndex || 0,
                                fromSymbol,
                                toSymbol,
                                fromLogo,
                                toLogo,
                                amountIn: formatToFixed(amountInStr, 6),
                                amountOut: formatToFixed(amountOutStr, 6)
                            })
                        }
                        if (allEvents.length >= limit) break
                    }

                    // 取最近的 limit 条（按区块与索引倒序）并填充 timeAgo
                    allEvents.sort((a,b) => {
                        if (a.blockNumber !== b.blockNumber) return b.blockNumber - a.blockNumber
                        if (a.transactionIndex !== b.transactionIndex) return (b.transactionIndex - a.transactionIndex)
                        return (b.logIndex - a.logIndex)
                    })
                    let top = allEvents.slice(0, Math.max(1, limit))
                    // 若最近1万区块无结果，回退扫描更长窗口，但分块查询以避免节点限制
                    if (top.length === 0) {
                        const windowSize = 4000
                        const windows = 10 // 最多回溯到最近 4 万区块
                        const fallbackPairs = Math.min(totalPairs, 500) // 回退阶段扫描更多交易对以覆盖更旧记录，但仍有限制
                        const startFallbackIndex = Math.max(totalPairs - fallbackPairs, 0)
                        const fallbackEvents = []
                        for (let i = totalPairs - 1; i >= startFallbackIndex; i--) {
                            let pairAddr = null
                            try { pairAddr = await factory.methods.allPairs(i).call() } catch(_){ pairAddr = null }
                            if (!pairAddr) continue
                            const pair = new vm.web3.eth.Contract(PAIR_ABI, pairAddr)
                            let token0 = null, token1 = null
                            try {
                                token0 = await pair.methods.token0().call()
                                token1 = await pair.methods.token1().call()
                            } catch(_) { token0 = null; token1 = null }
                            const meta0 = await loadTokenMeta(token0)
                            const meta1 = await loadTokenMeta(token1)
                            for (let w = 0; w < windows; w++) {
                                const toBlk = latest - (w * windowSize)
                                const fromBlk = Math.max(toBlk - windowSize, 0)
                                let evs = []
                                try {
                                    evs = await pair.getPastEvents('Swap', { fromBlock: fromBlk, toBlock: toBlk })
                                } catch(_){ evs = [] }
                                for (const ev of evs) {
                                    const rv = ev.returnValues || {}
                                    const amount0In = rv.amount0In || '0'
                                    const amount1In = rv.amount1In || '0'
                                    const amount0Out = rv.amount0Out || '0'
                                    const amount1Out = rv.amount1Out || '0'
                                    let fromSymbol = ''
                                    let toSymbol = ''
                                    let fromLogo = meta0.logo
                                    let toLogo = meta1.logo
                                    let amountInStr = '0'
                                    let amountOutStr = '0'
                                    if (vm.web3.utils.toBN(amount0Out).gt(vm.web3.utils.toBN('0'))) {
                                        fromSymbol = meta1.symbol
                                        toSymbol = meta0.symbol
                                        // 修正方向：输入为 token1，输出为 token0
                                        fromLogo = meta1.logo
                                        toLogo = meta0.logo
                                        amountInStr = toDecimalString(amount1In, meta1.decimals)
                                        amountOutStr = toDecimalString(amount0Out, meta0.decimals)
                                    } else {
                                        fromSymbol = meta0.symbol
                                        toSymbol = meta1.symbol
                                        // 修正方向：输入为 token0，输出为 token1
                                        fromLogo = meta0.logo
                                        toLogo = meta1.logo
                                        amountInStr = toDecimalString(amount0In, meta0.decimals)
                                        amountOutStr = toDecimalString(amount1Out, meta1.decimals)
                                    }
                                    fallbackEvents.push({
                                        txHash: ev.transactionHash,
                                        blockNumber: ev.blockNumber,
                                        transactionIndex: ev.transactionIndex || 0,
                                        logIndex: ev.logIndex || 0,
                                        fromSymbol,
                                        toSymbol,
                                        fromLogo,
                                        toLogo,
                                        amountIn: formatToFixed(amountInStr, 6),
                                        amountOut: formatToFixed(amountOutStr, 6)
                                    })
                                    if (fallbackEvents.length >= limit) break
                                }
                                if (fallbackEvents.length >= limit) break
                            }
                            if (fallbackEvents.length >= limit) break
                        }
                        fallbackEvents.sort((a,b) => {
                            if (a.blockNumber !== b.blockNumber) return b.blockNumber - a.blockNumber
                            if (a.transactionIndex !== b.transactionIndex) return (b.transactionIndex - a.transactionIndex)
                            return (b.logIndex - a.logIndex)
                        })
                        top = fallbackEvents.slice(0, Math.max(1, limit))
                    }
                    for (const it of top) {
                        try{
                            const blk = await vm.web3.eth.getBlock(it.blockNumber)
                            it.timeAgo = vm.formatTimeAgo(blk && blk.timestamp)
                        }catch(_){ it.timeAgo = ' ~ ' }
                    }
                    vm.swapHistory = top
                }catch(e){
                    console.error('fetchRecentSwaps error', e)
                    vm.swapHistory = []
                } finally {
                    vm.swapHistoryLoading = false
                }
            },
            // 更新报价与网络费用（在选择代币或滑点后调用）
            async updateQuoteAndFees(){
                const vm = this
                try{
                    if (!vm.web3) {
                        if (window.ethereum) {
                            vm.web3Provider = window.ethereum
                            vm.web3 = new Web3(vm.web3Provider)
                        } else {
                            vm.$message && vm.$message.error('未检测到钱包，请先连接')
                            return
                        }
                    }
                    if (!vm.ROUTER_ADDRESS) { vm.$message && vm.$message.error('路由合约地址缺失'); return }
                    const router = new vm.web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)

                    const toBN = vm.web3.utils.toBN
                    const pow10 = (n) => toBN('1' + '0'.repeat(n))
                    const toBaseUnit = (decimalStr, decimals) => {
                        decimalStr = String(decimalStr)
                        if (!decimalStr.includes('.')) return toBN(decimalStr).mul(pow10(decimals))
                        const [intPart, fracPartRaw] = decimalStr.split('.')
                        const fracPart = (fracPartRaw || '').slice(0, decimals)
                        const intBN = toBN(intPart || '0').mul(pow10(decimals))
                        const fracBN = fracPart ? toBN(fracPart).mul(pow10(decimals - fracPart.length)) : toBN('0')
                        return intBN.add(fracBN)
                    }
                    const toDecimalString = (bn, decimals) => {
                        const str = toBN(bn).toString()
                        const d = Number(decimals)
                        if (d === 0) return str
                        if (str.length <= d) return `0.${'0'.repeat(d - str.length)}${str}`
                        return `${str.slice(0, str.length - d)}.${str.slice(str.length - d)}`
                    }

                    const isFromNative = !vm.from.contract_address
                    const isToNative = !vm.to.contract_address

                    let fromDecimals = 18
                    let toDecimals = 18
                    if (!isFromNative) {
                        try { fromDecimals = Number(await (new vm.web3.eth.Contract(ERC20_ABI, vm.from.contract_address)).methods.decimals().call()) } catch(_) { fromDecimals = 18 }
                    }
                    if (!isToNative) {
                        try { toDecimals = Number(await (new vm.web3.eth.Contract(ERC20_ABI, vm.to.contract_address)).methods.decimals().call()) } catch(_) { toDecimals = 18 }
                    }

                    let WETH = null
                    try { WETH = await router.methods.WETH().call() } catch (_) { WETH = null }
                    const toIsWETH = !isToNative && WETH && vm.to.contract_address && vm.to.contract_address.toLowerCase() === String(WETH).toLowerCase()
                    const fromIsWETH = !isFromNative && WETH && vm.from.contract_address && vm.from.contract_address.toLowerCase() === String(WETH).toLowerCase()
                    const sameToken = !isFromNative && !isToNative && vm.from.contract_address.toLowerCase() === vm.to.contract_address.toLowerCase()

                    // 特殊场景：ETH<->WETH 或 相同代币，避免触发 IDENTICAL_ADDRESSES
                    if (isFromNative && toIsWETH) {
                        // 报价 1:1
                        vm.feeRate = formatToFixed('1', 6)
                        // 单价与结果：1:1
                        const amountStr = String(vm.num || '0')
                        vm.amountOut = vm.feeRate
                        vm.calculatedOut = formatToFixed(amountStr || '0', 6)
                        // 估算网络费用：WETH.deposit
                        try{
                            const accounts = await vm.web3.eth.getAccounts(); const addr = accounts[0]
                            const gasPrice = await vm.web3.eth.getGasPrice()
                            const addBuf = (gas) => toBN(gas).mul(toBN('120')).div(toBN('100'))
                            const amountStr = String(vm.num || '0')
                            const amountIn = (Number(amountStr) > 0) ? toBaseUnit(amountStr, fromDecimals) : pow10(fromDecimals)
                            const weth = new vm.web3.eth.Contract(WETH_ABI, WETH)
                            const gas = await weth.methods.deposit().estimateGas({ from: addr, value: amountIn.toString() })
                            const gasWei = toBN(gasPrice).mul(addBuf(gas))
                            const gasWeiStr = gasWei.toString()
                            const ethStr = gasWeiStr.length <= 18 ? `0.${'0'.repeat(18 - gasWeiStr.length)}${gasWeiStr}` : `${gasWeiStr.slice(0, gasWeiStr.length - 18)}.${gasWeiStr.slice(gasWeiStr.length - 18)}`
                            vm.networkFee = formatToFixed(ethStr, 6)
                        }catch(err){ vm.networkFee = null }
                        return
                    }
                    if (isToNative && fromIsWETH) {
                        // 报价 1:1
                        vm.feeRate = formatToFixed('1', 6)
                        // 单价与结果：1:1
                        const amountStr = String(vm.num || '0')
                        vm.amountOut = vm.feeRate
                        vm.calculatedOut = formatToFixed(amountStr || '0', 6)
                        // 估算网络费用：WETH.withdraw
                        try{
                            const accounts = await vm.web3.eth.getAccounts(); const addr = accounts[0]
                            const gasPrice = await vm.web3.eth.getGasPrice()
                            const addBuf = (gas) => toBN(gas).mul(toBN('120')).div(toBN('100'))
                            const amountStr = String(vm.num || '0')
                            const amountIn = (Number(amountStr) > 0) ? toBaseUnit(amountStr, fromDecimals) : pow10(fromDecimals)
                            const weth = new vm.web3.eth.Contract(WETH_ABI, WETH)
                            const gas = await weth.methods.withdraw(amountIn.toString()).estimateGas({ from: addr })
                            const gasWei = toBN(gasPrice).mul(addBuf(gas))
                            const gasWeiStr = gasWei.toString()
                            const ethStr = gasWeiStr.length <= 18 ? `0.${'0'.repeat(18 - gasWeiStr.length)}${gasWeiStr}` : `${gasWeiStr.slice(0, gasWeiStr.length - 18)}.${gasWeiStr.slice(gasWeiStr.length - 18)}`
                            vm.networkFee = formatToFixed(ethStr, 6)
                        }catch(err){ vm.networkFee = null }
                        return
                    }
                    if (sameToken) {
                        vm.feeRate = formatToFixed('1', 6)
                        vm.networkFee = formatToFixed('0', 6)
                        const amountStr = String(vm.num || '0')
                        vm.amountOut = vm.feeRate
                        vm.calculatedOut = formatToFixed(amountStr || '0', 6)
                        return
                    }

                    const isAddr = (a) => a && vm.web3.utils.isAddress(a)
                    let path = []
                    if (isFromNative) {
                        if (!WETH) { vm.$message && vm.$message.error('路由未配置 WETH 地址'); return }
                        if (!isAddr(vm.to.contract_address)) { vm.$message && vm.$message.error('目标代币地址无效'); return }
                        path = [WETH, vm.to.contract_address]
                    }
                    else if (isToNative) {
                        if (!WETH) { vm.$message && vm.$message.error('路由未配置 WETH 地址'); return }
                        if (!isAddr(vm.from.contract_address)) { vm.$message && vm.$message.error('来源代币地址无效'); return }
                        path = [vm.from.contract_address, WETH]
                    }
                    else {
                        if (!isAddr(vm.from.contract_address) || !isAddr(vm.to.contract_address)) { vm.$message && vm.$message.error('代币地址无效'); return }
                        path = [vm.from.contract_address, vm.to.contract_address]
                    }

                    // 1单位 from 的报价
                    const oneUnit = pow10(fromDecimals)
                    try{
                        const amountsOut = await router.methods.getAmountsOut(oneUnit.toString(), path).call()

                        console.log(amountsOut)
                        const outLast = amountsOut[amountsOut.length - 1]
                        const outDec = toDecimalString(outLast, toDecimals)
                        vm.feeRate = formatToFixed(outDec, 6)
                        vm.amountOut = vm.feeRate
                    }catch(err){
                        console.error('getAmountsOut for feeRate error', err)
                        vm.$message && vm.$message.error('无法获取报价，请稍后重试')
                        vm.feeRate = null
                        vm.amountOut = null
                    }

                    // 依据实时单价计算当前输入金额的兑换结果（线性估算）
                    try{
                        const amountStr = String(vm.num || '0')
                        if (vm.amountOut && Number(amountStr) > 0) {
                            const est = Number(amountStr) * Number(vm.amountOut)
                            vm.calculatedOut = formatToFixed(String(est), 6)
                        } else {
                            vm.calculatedOut = ''
                        }
                    }catch(err){
                        console.error('calculate amountOutTotal error', err)
                        vm.calculatedOut = ''
                    }

                    // 估算网络费用（优先精确估算，失败则使用保守常量）
                    try{
                        const gasPrice = await vm.web3.eth.getGasPrice()
                        const addBuffer = (gas) => {
                            const g = toBN(gas)
                            return g.mul(toBN('120')).div(toBN('100'))
                        }

                        const amountStr = String(vm.num || '0')
                        const amountIn = (Number(amountStr) > 0) ? toBaseUnit(amountStr, fromDecimals) : oneUnit

                        let gas
                        const accounts = await vm.web3.eth.getAccounts()
                        const addr = accounts[0]
                        if (isFromNative) {
                            gas = await router.methods.swapExactETHForTokens(
                                oneUnit.toString(), // 任意最小接收值，仅用于估算gas
                                path,
                                addr,
                                Math.floor(Date.now()/1000) + 1800
                            ).estimateGas({ from: addr, value: amountIn.toString() })
                        } else if (isToNative) {
                            // 估算可能因 allowance revert，加入 try/catch
                            try{
                                gas = await router.methods.swapExactTokensForETH(
                                    amountIn.toString(),
                                    oneUnit.toString(),
                                    path,
                                    addr,
                                    Math.floor(Date.now()/1000) + 1800
                                ).estimateGas({ from: addr })
                            }catch(_){ gas = toBN('220000') }
                        } else {
                            try{
                                gas = await router.methods.swapExactTokensForTokens(
                                    amountIn.toString(),
                                    oneUnit.toString(),
                                    path,
                                    addr,
                                    Math.floor(Date.now()/1000) + 1800
                                ).estimateGas({ from: addr })
                            }catch(_){ gas = toBN('240000') }
                        }

                        const gasWei = toBN(gasPrice).mul(toBN(gas))
                        const gasWeiStr = gasWei.toString()
                        const ethStr = gasWeiStr.length <= 18 ? `0.${'0'.repeat(18 - gasWeiStr.length)}${gasWeiStr}` : `${gasWeiStr.slice(0, gasWeiStr.length - 18)}.${gasWeiStr.slice(gasWeiStr.length - 18)}`
                        vm.networkFee = formatToFixed(ethStr, 6)
                    }catch(err){
                        console.error('estimate network fee error', err)
                        vm.networkFee = null
                    }
                }catch(e){
                    console.error('updateQuoteAndFees error', e)
                    vm.feeRate = null
                    vm.networkFee = null
                }
            },
            // 确保代币授权足够；若直接授权失败，自动先授权为0再授权目标值（兼容USDT等代币）
            async ensureTokenAllowance(tokenAddress, owner, spender, requiredAmountBN) {
                const vm = this
                const toBN = vm.web3.utils.toBN
                const c = new vm.web3.eth.Contract(ERC20_ABI, tokenAddress)
                const gasPrice = await vm.web3.eth.getGasPrice()
                const addBuffer = (gas) => {
                    const g = toBN(gas)
                    return g.mul(toBN('120')).div(toBN('100'))
                }

                const current = await c.methods.allowance(owner, spender).call()
                if (toBN(current).gte(requiredAmountBN)) return

                vm.buttonState = 'authing'
                // 先尝试直接授权 requiredAmount
                try {
                    // 预执行，捕获潜在 revert
                    await c.methods.approve(spender, requiredAmountBN.toString()).call({ from: owner })
                    const gas = await c.methods.approve(spender, requiredAmountBN.toString()).estimateGas({ from: owner })
                    await c.methods.approve(spender, requiredAmountBN.toString()).send({ from: owner, gasPrice, gas: addBuffer(gas).toString(), type: '0x0' })
                    vm.buttonState = 'auth_success'
                    return
                } catch (err) {
                    console.error('Direct approve failed, fallback to zero-reset then approve:', err && err.message || err)
                }

                // 某些代币（如USDT）需要先把 allowance 置为0，再设置新值
                try {
                    const zeroGas = await c.methods.approve(spender, '0').estimateGas({ from: owner })
                    await c.methods.approve(spender, '0').send({ from: owner, gasPrice, gas: addBuffer(zeroGas).toString(), type: '0x0' })
                } catch (err) {
                    vm.buttonState = 'auth_fail'
                    console.error('Approve zero failed:', err && err.message || err)
                    throw err
                }

                const gas = await c.methods.approve(spender, requiredAmountBN.toString()).estimateGas({ from: owner })
                await c.methods.approve(spender, requiredAmountBN.toString()).send({ from: owner, gasPrice, gas: addBuffer(gas).toString(), type: '0x0' })
                vm.buttonState = 'auth_success'
            },
            selectSelectpop(type){
                let vm = this
                vm.selectpop = true
                vm.selectpop_type = type
            },
            async selectPair(item){
                let vm = this
                if (vm.selectpop_type == 1){
                    vm.from = item

                }else{
                    vm.to = item
                }

                try{
                    let balanceStr = '0'
                    if (!item.contract_address){
                        balanceStr = await vm.getMainBalance()
                    }else{
                        balanceStr = await vm.getTokenBalance(item.contract_address)
                    }
                    if (vm.selectpop_type == 1){
                        vm.from.balance = balanceStr
                    }else{
                        vm.to.balance = balanceStr
                    }
                }catch (e){
                    console.error('selectPair set from.balance error', e)
                    if (vm.selectpop_type == 1){
                        vm.from.balance = '0'
                    }else{
                        vm.to.balance = '0'
                    }
                }

                vm.selectpop = false
                // 选择代币后刷新报价与网络费用
                vm.updateQuoteAndFees && vm.updateQuoteAndFees().catch(e => console.error('updateQuoteAndFees after selectPair error', e))
            },
			async getMainBalance(account){
				const vm = this
				try {
					if (!vm.web3) {
						if (window.ethereum) {
							vm.web3Provider = window.ethereum
							vm.web3 = new Web3(vm.web3Provider)
						} else {
							throw new Error('No web3 provider')
						}
					}
					const accounts = await vm.web3.eth.getAccounts()
					const addr = account || accounts[0]
					if (!addr) throw new Error('No account')
					const wei = await vm.web3.eth.getBalance(addr)
					const etherStr = vm.web3.utils.fromWei(wei, 'ether')
					return formatToFixed(etherStr, 6)
				} catch (e) {
					console.error('getMainBalance error', e)
					return '0'
				}
			},
			async getTokenBalance(contractAddress, account){
				const vm = this
				try {
					if (!vm.web3) {
						if (window.ethereum) {
							vm.web3Provider = window.ethereum
							vm.web3 = new Web3(vm.web3Provider)
						} else {
							throw new Error('No web3 provider')
						}
					}
					if (!contractAddress) throw new Error('No contract address')
					const accounts = await vm.web3.eth.getAccounts()
					const addr = account || accounts[0]
					if (!addr) throw new Error('No account')
					const contract = new vm.web3.eth.Contract(ERC20_ABI, contractAddress)
					const balance = await contract.methods.balanceOf(addr).call()
					let decimals = 18
					try {
						decimals = await contract.methods.decimals().call()
					} catch (e) {
						decimals = 18
					}
					const str = vm.web3.utils.toBN(balance).toString()
					const d = Number(decimals)
					if (d === 0) return formatToFixed(str, 6)
					if (str.length <= d) {
						const out = `0.${'0'.repeat(d - str.length)}${str}`
						return formatToFixed(out, 6)
					}
					const out = `${str.slice(0, str.length - d)}.${str.slice(str.length - d)}`
					return formatToFixed(out, 6)
				} catch (e) {
					console.error('getTokenBalance error', e)
					return '0'
				}
			},
            async refreshBalances(){
                const vm = this
                try{
                    const loadBal = async (tokenObj) => {
                        if (!tokenObj || !tokenObj.contract_address){
                            return await vm.getMainBalance()
                        }
                        return await vm.getTokenBalance(tokenObj.contract_address)
                    }

                    const fromBal = await loadBal(vm.from)
                    vm.from.balance = fromBal

                    const toBal = await loadBal(vm.to)
                    vm.to.balance = toBal
                }catch (e){
                    console.error('refreshBalances error', e)
                }
            },
            async getpop(){
                const vm = this
                // vm.$message.error('暂未开放')
                // return;
                try {
                    if (vm.swapButtonDisabled) return
                    if (!vm.web3) {
                        if (window.ethereum) {
                            vm.web3Provider = window.ethereum
                            vm.web3 = new Web3(vm.web3Provider)
                        } else {
                            vm.$message && vm.$message.error('未检测到钱包，请先连接')
                            return
                        }
                    }
                    // 校验当前网络是否为 ROON 主网（chainId = 1492）
                    try {
                        const chainId = await vm.web3.eth.getChainId()
                        if (Number(chainId) !== 1492) {
                            vm.$message && vm.$message.error('请切换到ROON主网')
                            return
                        }
                    } catch(_) {
                        vm.$message && vm.$message.error('无法获取网络信息，请检查钱包连接')
                        return
                    }
                    const accounts = await vm.web3.eth.getAccounts()
                    const addr = accounts[0]
                    if (!addr) { vm.$message && vm.$message.error('未获取到账户，请登录钱包'); return }
                    if (!vm.ROUTER_ADDRESS) { vm.$message && vm.$message.error('路由合约地址缺失'); return }
                    const router = new vm.web3.eth.Contract(ROUTER_ABI, vm.ROUTER_ADDRESS)

                    const amountStr = String(vm.num || '0')
                    if (!amountStr || Number(amountStr) <= 0) { vm.$message && vm.$message.error('请输入有效的兑换数量'); return }

                    const slippageBps = vm.shuzhi === 1 ? 10 : vm.shuzhi === 2 ? 50 : 100
                    const deadline = Math.floor(Date.now() / 1000) + 1800

                    const toBN = vm.web3.utils.toBN
                    const pow10 = (n) => toBN('1' + '0'.repeat(n))
                    const toBaseUnit = (decimalStr, decimals) => {
                        decimalStr = String(decimalStr)
                        if (!decimalStr.includes('.')) return toBN(decimalStr).mul(pow10(decimals))
                        const [intPart, fracPartRaw] = decimalStr.split('.')
                        const fracPart = (fracPartRaw || '').slice(0, decimals)
                        const intBN = toBN(intPart || '0').mul(pow10(decimals))
                        const fracBN = fracPart ? toBN(fracPart).mul(pow10(decimals - fracPart.length)) : toBN('0')
                        return intBN.add(fracBN)
                    }

                    const isFromNative = !vm.from.contract_address
                    const isToNative = !vm.to.contract_address
                    let fromDecimals = 18
                    if (!isFromNative) {
                        const fromContract = new vm.web3.eth.Contract(ERC20_ABI, vm.from.contract_address)
                        try { fromDecimals = Number(await fromContract.methods.decimals().call()) } catch(e) { fromDecimals = 18 }
                    }
                    const amountIn = toBaseUnit(amountStr, fromDecimals)

                    let WETH = null
                    try { WETH = await router.methods.WETH().call() } catch (e) { WETH = null }

                    const toIsWETH = !isToNative && WETH && vm.to.contract_address && vm.to.contract_address.toLowerCase() === String(WETH).toLowerCase()
                    const fromIsWETH = !isFromNative && WETH && vm.from.contract_address && vm.from.contract_address.toLowerCase() === String(WETH).toLowerCase()
                    const sameToken = !isFromNative && !isToNative && vm.from.contract_address.toLowerCase() === vm.to.contract_address.toLowerCase()

                    // 处理特殊场景：ETH<->WETH wrap/unwrap，或相同代币
                    // 拦截主币→主币选择
                    if (isFromNative && isToNative) {
                        vm.$message && vm.$message.error('请选择不同的币种进行兑换')
                        return
                    }
                    if (isFromNative && toIsWETH) {
                        // wrap ETH -> WETH
                        const weth = new vm.web3.eth.Contract(WETH_ABI, WETH)
                        const gasPrice = await vm.web3.eth.getGasPrice()
                        const addBuffer = (gas) => {
                            const g = toBN(gas)
                            return g.mul(toBN('120')).div(toBN('100'))
                        }
                        vm.buttonState = 'swapping'
                        const gas = await weth.methods.deposit().estimateGas({ from: addr, value: amountIn.toString() })
                        await weth.methods.deposit().send({ from: addr, value: amountIn.toString(), gasPrice, gas: addBuffer(gas).toString(), type: '0x0' })
                        vm.buttonState = 'swap_success'
                        await vm.refreshBalances()
                        vm.$message && vm.$message.success('兑换成功')
                        // 成功后重置输入与预估输出
                        vm.num = '0'
                        vm.calculatedOut = '0'
                        vm.fetchRecentSwaps && vm.fetchRecentSwaps().catch(err => console.error('fetchRecentSwaps after success error', err))
                        setTimeout(() => { vm.buttonState = 'idle' }, 1500)
                        return
                    }
                    if (isToNative && fromIsWETH) {
                        // unwrap WETH -> ETH
                        const weth = new vm.web3.eth.Contract(WETH_ABI, WETH)
                        const gasPrice = await vm.web3.eth.getGasPrice()
                        const addBuffer = (gas) => {
                            const g = toBN(gas)
                            return g.mul(toBN('120')).div(toBN('100'))
                        }
                        vm.buttonState = 'swapping'
                        const gas = await weth.methods.withdraw(amountIn.toString()).estimateGas({ from: addr })
                        await weth.methods.withdraw(amountIn.toString()).send({ from: addr, gasPrice, gas: addBuffer(gas).toString(), type: '0x0' })
                        vm.buttonState = 'swap_success'
                        await vm.refreshBalances()
                        vm.$message && vm.$message.success('兑换成功')
                        // 成功后重置输入与预估输出
                        vm.num = '0'
                        vm.calculatedOut = '0'
                        vm.fetchRecentSwaps && vm.fetchRecentSwaps().catch(err => console.error('fetchRecentSwaps after success error', err))
                        setTimeout(() => { vm.buttonState = 'idle' }, 1500)
                        return
                    }
                    if (sameToken) {
                        vm.$message && vm.$message.error('相同代币不可兑换')
                        return
                    }

                    let path = []
                    const isAddr = (a) => a && vm.web3.utils.isAddress(a)
                    if (isFromNative) {
                        if (!WETH) { vm.$message && vm.$message.error('路由未配置 WETH 地址'); return }
                        if (!isAddr(vm.to.contract_address)) { vm.$message && vm.$message.error('目标代币地址无效'); return }
                        path = [WETH, vm.to.contract_address]
                    } else if (isToNative) {
                        if (!WETH) { vm.$message && vm.$message.error('路由未配置 WETH 地址'); return }
                        if (!isAddr(vm.from.contract_address)) { vm.$message && vm.$message.error('来源代币地址无效'); return }
                        path = [vm.from.contract_address, WETH]
                    } else {
                        if (!isAddr(vm.from.contract_address) || !isAddr(vm.to.contract_address)) { vm.$message && vm.$message.error('代币地址无效'); return }
                        path = [vm.from.contract_address, vm.to.contract_address]
                    }

                    const amountsOut = await router.methods.getAmountsOut(amountIn.toString(), path).call()
                    const outBN = toBN(amountsOut[amountsOut.length - 1])
                    const amountOutMin = outBN.mul(toBN(10000 - slippageBps)).div(toBN(10000))

                    const gasPrice = await vm.web3.eth.getGasPrice()
                    const addBuffer = (gas) => {
                        const g = toBN(gas)
                        return g.mul(toBN('120')).div(toBN('100'))
                    }

                    if (isFromNative) {
                        vm.buttonState = 'swapping'
                        const gas = await router.methods.swapExactETHForTokens(
                            amountOutMin.toString(),
                            path,
                            addr,
                            deadline
                        ).estimateGas({ from: addr, value: amountIn.toString() })
                        await router.methods.swapExactETHForTokens(
                            amountOutMin.toString(),
                            path,
                            addr,
                            deadline
                        ).send({ from: addr, value: amountIn.toString(), gasPrice, gas: addBuffer(gas).toString(), type: '0x0' })
                        vm.buttonState = 'swap_success'
                        vm.$message && vm.$message.success('兑换成功')
                    } else if (isToNative) {
                        await vm.ensureTokenAllowance(vm.from.contract_address, addr, vm.ROUTER_ADDRESS, amountIn)
                        vm.buttonState = 'swapping'
                        const gas = await router.methods.swapExactTokensForETH(
                            amountIn.toString(),
                            amountOutMin.toString(),
                            path,
                            addr,
                            deadline
                        ).estimateGas({ from: addr })
                        await router.methods.swapExactTokensForETH(
                            amountIn.toString(),
                            amountOutMin.toString(),
                            path,
                            addr,
                            deadline
                        ).send({ from: addr, gasPrice, gas: addBuffer(gas).toString(), type: '0x0' })
                        vm.buttonState = 'swap_success'
                        vm.$message && vm.$message.success('兑换成功')
                    } else {
                        await vm.ensureTokenAllowance(vm.from.contract_address, addr, vm.ROUTER_ADDRESS, amountIn)
                        vm.buttonState = 'swapping'
                        const gas = await router.methods.swapExactTokensForTokens(
                            amountIn.toString(),
                            amountOutMin.toString(),
                            path,
                            addr,
                            deadline
                        ).estimateGas({ from: addr })
                        await router.methods.swapExactTokensForTokens(
                            amountIn.toString(),
                            amountOutMin.toString(),
                            path,
                            addr,
                            deadline
                        ).send({ from: addr, gasPrice, gas: addBuffer(gas).toString(), type: '0x0' })
                        vm.buttonState = 'swap_success'
                        vm.$message && vm.$message.success('兑换成功')
                    }
                    // 成功后重置输入与预估输出
                    vm.num = '0'
                    vm.calculatedOut = '0'

                    await vm.refreshBalances()
                    // 成功后刷新最近的记录
                    vm.fetchRecentSwaps && vm.fetchRecentSwaps().catch(err => console.error('fetchRecentSwaps after success error', err))
                    setTimeout(() => { vm.buttonState = 'idle' }, 1500)
                } catch (e) {
                    console.error('swap error', e)
                    const msg = e && e.message ? e.message : '兑换失败'
                    vm.$message && vm.$message.error(msg)
                    vm.buttonState = vm.buttonState === 'authing' ? 'auth_fail' : 'swap_fail'
                }
            },
			getpopOld(){
				this.zoushipop=true
				setTimeout(() => {
					this.initEcharts();
				}, 200)

			},
			getshuzhi(e){
				this.shuzhi = e
				// 选择滑点后刷新报价与网络费用
				this.updateQuoteAndFees && this.updateQuoteAndFees().catch(err => console.error('updateQuoteAndFees after slippage change error', err))
			},
			// 跳转到添加流动性页面
			goToAddLp(){
				this.$router.push({ path: '/Chi' })
			},
			initEcharts() {
				const option = {
					animation: false,
					color: colorList,
					title: {
						left: 'center',
						text: ''
					},
					legend: {
						top: 40,
						data: ['日K', 'MA5', 'MA10', 'MA20', 'MA30']
					},
					tooltip: {
						triggerOn: 'none',
						transitionDuration: 0,
						confine: true,
						borderRadius: 4,
						borderWidth: 1,
						borderColor: '#333',
						backgroundColor: 'rgba(255,255,255,0.9)',
						textStyle: {
							fontSize: 12,
							color: '#333'
						},
						position: function(pos, params, el, elRect, size) {
							const obj = {
								top: 60
							};
							obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
							return obj;
						}
					},
					axisPointer: {
						link: [
							{
								xAxisIndex: [0, 1]
							}
						]
					},
					// dataZoom: [
						// {
						// 	type: 'slider',
						// 	xAxisIndex: [0, 1],
						// 	realtime: false,
						// 	start: 20,
						// 	end: 70,
						// 	top: 45,
						// 	height: 20,
						// 	handleIcon:
						// 		'path://M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
						// 	handleSize: '120%'
						// },
						// {
						// 	type: 'inside',
						// 	xAxisIndex: [0, 1],
						// 	start: 40,
						// 	end: 70,
						// 	top: 30,
						// 	height: 20
						// }
					// ],
					xAxis: [
						{
							type: 'category',
							data: dates,
							boundaryGap: false,
							axisLine: { lineStyle: { color: '#777' } },
							axisLabel: {
								formatter: function(value) {
									return echarts.format.formatTime('MM-dd', value);
								}
							},
							min: 'dataMin',
							max: 'dataMax',
							axisPointer: {
								show: true
							}
						},
						{
							type: 'category',
							gridIndex: 1,
							data: dates,
							boundaryGap: false,
							splitLine: { show: false },
							axisLabel: { show: false },
							axisTick: { show: false },
							axisLine: { lineStyle: { color: '#777' } },
							min: 'dataMin',
							max: 'dataMax',
							axisPointer: {
								type: 'shadow',
								label: { show: false },
								triggerTooltip: true,
								handle: {
									show: true,
									margin: 30,
									color: '#B80C00'
								}
							}
						}
					],
					yAxis: [
						{
							scale: true,
							splitNumber: 2,
							axisLine: { lineStyle: { color: '#777' } },
							splitLine: { show: true },
							axisTick: { show: false },
							axisLabel: { show: true, inside: false }
						},
						{
							scale: true,
							gridIndex: 1,
							splitNumber: 2,
							axisLabel: { show: false },
							axisLine: { show: false },
							axisTick: { show: false },
							splitLine: { show: false }
						}
					],
					grid: [
						{
							left: 44,
							right: 20,
							top: 110,
							height: 120
						},
						{
							left: 44,
							right: 20,
							height: 40,
							top: 260
						}
					],
					graphic: [
						{
							type: 'group',
							left: 'center',
							top: 70,
							width: 300,
							bounding: 'raw',
							children: [
								{
									id: 'MA5',
									type: 'text',
									style: { fill: colorList[1], font: labelFont },
									left: 0
								},
								{
									id: 'MA10',
									type: 'text',
									style: { fill: colorList[2], font: labelFont },
									left: 'center'
								},
								{
									id: 'MA20',
									type: 'text',
									style: { fill: colorList[3], font: labelFont },
									right: 0
								}
							]
						}
					],
					series: [
						{
							name: 'Volume',
							type: 'bar',
							xAxisIndex: 1,
							yAxisIndex: 1,
							itemStyle: {
								color: '#7fbe9e'
							},
							emphasis: {
								itemStyle: {
									color: '#140'
								}
							},
							data: volumes
						},
						{
							type: 'candlestick',
							name: '日K',
							data: data,
							itemStyle: {
								color: '#ef232a',
								color0: '#14b143',
								borderColor: '#ef232a',
								borderColor0: '#14b143'
							},
							emphasis: {
								itemStyle: {
									color: 'black',
									color0: '#444',
									borderColor: 'black',
									borderColor0: '#444'
								}
							}
						},
						{
							name: 'MA5',
							type: 'line',
							data: dataMA5,
							smooth: true,
							showSymbol: false,
							lineStyle: {
								width: 1
							}
						},
						{
							name: 'MA10',
							type: 'line',
							data: dataMA10,
							smooth: true,
							showSymbol: false,
							lineStyle: {
								width: 1
							}
						},
						{
							name: 'MA20',
							type: 'line',
							data: dataMA20,
							smooth: true,
							showSymbol: false,
							lineStyle: {
								width: 1
							}
						}
					]
				};
				const myChart = echarts.init(document.getElementById("mychart"));
				myChart.setOption(option);
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					myChart.resize();
				});
			}
		},
	};
</script>

<style scoped >
    .kxian {
        -webkit-overflow-scrolling: touch;
    }
    .tf-switch{
        display:flex;
        gap:8px;
        padding:8px 15px 2px 15px;
    }
    .tf-item{
        font-size:12px;
        color:#999;
        padding:6px 10px;
        border:1px solid #333;
        border-radius:12px;
        cursor:pointer;
        user-select:none;
    }
    .tf-item.active{
        color:#fff;
        border-color:#EB470C;
        background-color:#EB470C20;
    }
    .echart {
        width: 100%;
        height: 420px;
        touch-action: pan-x pan-y;
    }
	.top-actions{
		display: flex;
		justify-content: flex-end;
		padding: 0 15px;
		margin-top: 10px;
	}
	.btn-liquidity{
		height: 36px;
		background: #EB470C;
		border-radius: 18px;
		padding: 0 14px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 14px;
		color: #FFFFFF;
	}
	.daiview{
		background: #19191A;
		border-radius: 10px;
		padding: 15px;
		margin:5px 15px;
	}
	.daione{
		display: flex;
		flex-direction: row;
		align-items: center;

	}
	.jiaoname{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
	}
	.icon_sz{
		width: 19px;
		height: 20px;
		margin-left: auto;
	}
	.cong{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 20px 0 9px;
	}
	.congname{
		font-weight: 500;
		font-size: 12px;
		color: #999999;
	}
	.yue{
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		margin-left: auto;
	}
	.jiaoone{
		background: #0F0F10;
		border-radius: 10px;
		padding: 10px 10px 10px 15px;
		display: flex;
		flex-direction: column;
	}
	.jiaohead{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.jiaoshu{
		font-weight: bold;
		font-size: 20px;
		color: #FFFFFF;
		width: 57%;
	}

	.jhrig{
		margin-left: auto;
		padding: 8px 10px;
		background: rgba(255, 255, 255,0.2);
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.icon_yth{
		margin-right: 3px;
		width: 22px;
		height: 22px;
	}
	.icon_qh{
		margin-left: 10px;
		width: 11px;
		height: 11px;
	}
	.jrname{
		font-weight: bold;
		font-size: 20px;
		color: #FFFFFF;
	}
	.yudeng{
		font-weight: bold;
		font-size: 15px;
		color: #CCCCCC;
		display: block;
		margin-top: 12px;
	}
	.jiaoimg{
		width: 80px;
		height: 80px;
		margin: 0 auto;
		display: block;
	}
	.ctwo{
		margin-top: 0;
	}
	.feiview{
		padding: 15px;
		background: #3B1F15;
		border-radius: 10px;
		display: flex;
		flex-direction: column;
		margin-top: 15px;
	}
	.feiitem{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 10px;
	}
	.feiitem:last-child{
		margin-bottom: 0;
	}
	.feileft{
		font-weight: 500;
		font-size: 12px;
		color: #CCCCCC;
	}
	.feirig{
		margin-left: auto;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
	}
	.bai{
		color: #EB470C;
	}
	.jdai{
		margin: 20px 0;
		height: 50px;
		background: #EB470C;
		border-radius: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.daiviewtwo{
		margin-top: 15px;
	}

	.jilist{
		display: flex;
		flex-direction: row;
		align-items: center;
		background: #262626;
		border-radius: 10px;
		padding:10px 15px;
		margin-bottom: 10px;

	}
	.jilist:last-child{
		margin-bottom: 0;
	}
	.icon_ythicon{
		width: 20px;
		height: 20px;
	}
	.jiaohuan{
		width: 10px;
		height: 10px;
		margin: 0 10px;
	}
	.daiviewtwo .daione{
		margin-bottom: 15px;
	}
	.jinav{
		display: flex;
		flex-direction: column;
		margin-left: 10px;
		flex: 1;
		min-width: 0;
	}
	.jinavname{
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
	}
	.jinavtime{
		font-weight: 500;
		font-size: 10px;
		display: inline-block;
		margin-top: 8px;
		color: #999999;
		width: 100%;
	}
	.jiright{
		margin-left: auto;
	}
	.ztai{
		padding: 5px 8px;
		background: #34CE5F;
		border-radius: 5px;
		font-weight: 500;
		font-size: 10px;
		color: #FFFFFF;
	}
	.dai{
		background: #CE7934;
	}
	/* 核心代码 */
	.ellipsis {
		white-space: nowrap; /* 强制文本不换行 */
		overflow: hidden;    /* 隐藏超出容器的内容 */
		text-overflow: ellipsis; /* 超出部分显示省略号（...） */
	}
	.huaview{
		height: 40px;
		background: #262626;
		border-radius: 10px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 15px;
	}
	.huaname{
		font-weight: bold;
		font-size: 13px;
		color: #CCCCCC;
		display: inline-block;
		margin-left: 15px;
	}
	.huaright{
		display: flex;
		flex-direction: row;
		margin-left: auto;
		align-items: center;
		height: 100%;

	}
	.huaitem{
		min-width: 60px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
		font-size: 13px;
		color: #FFFFFF;
		height: 100%;
	}
	.hactive{
		background: #EB470C;
		border-radius: 10px;
	}

	.jiepopview{
		background: #19191A;
		border-radius: 15px 15px 0px 0px;
		padding: 20px;
	}
	.jieone{
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		margin-bottom: 22px;
	}
	.xname{
		font-weight: bold;
		font-size: 18px;
		color: #FFFFFF;
	}
	.icon_gb{
		width: 16px;
		height: 16px;
		position: absolute;
		right: 15px;
		top: 20px;
	}
	.jipoplist{
		background: #0F0F10;
		border-radius: 10px;
		padding:10px 15px;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 12px;

	}
	.niconpop{
		margin-right: 10px;
		width: 30px;
		height: 30px;

	}
	.dpopright{
		margin-left: 10px;
		display: flex;
		flex-direction: column;
		width: 83%;
	}
	.dpopone{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.popname{
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.popname{
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
	}
	.ml{
		margin-left: auto;
	}
	.popnametwo{
		font-weight: 400;
		font-size: 12px;
		color: #CCCCCC;
	}
	.mt-two{
		margin-top: 4px;
	}
	.jipopactive{
		background: #3B1F15;
		border-radius: 10px;
		border: 1px solid #EB470C;
	}


	/* 走势 */
	.zsone{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.zouicon{
		width: 35px;
		height: 35px;
	}
	.zouicontwo{
		position: relative;
		z-index: 1;
		left: -10px;
	}
	.zoutit{
		font-weight: 500;
		font-size: 22px;
		color: #FFFFFF;
	}
	.qieicon{
		width: 15px;
		height: 15px;
		margin-left: 10px;
	}
	.zounum{
		display: block;
		margin: 10px 0 15px;
		font-weight: bold;
		font-size: 30px;
		color: #FFFFFF;
	}
	.zoutimes{
		display: flex;
		flex-direction: row;
		/* padding: 0 20px; */
		justify-content: space-between;
	}
	.zounewtem{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 33.33%;
	}
	.onitem{
		justify-content: flex-start;
		align-items: flex-start;
	}
	.zhname{
		font-weight: bold;
		font-size: 12px;
		color: #FFFFFF;
	}
	.threeitem{
		align-items: flex-end;
	}
	.zhshu{
		font-weight: bold;
		font-size: 16px;
		color: #FFFFFF;
		display: block;
		margin-top: 6px;
	}
	.lv{
		color: #29D2A3;
	}
	.shu{
		width: 100%;
		height: 10px;
		display: block;
		margin: 15px 0 10px;
		background-color: rgba(31, 31, 31,1);
	}
	.jiepopviewtwo{
		background: #19191A;
		border-radius: 15px 15px 0px 0px;
		padding: 20px 0;
	}
	.zounewpop{
		padding: 0 20px;
	}
</style>
                    // 组合校验：不允许两边都为主币
                    if (isFromNative && isToNative) {
                        vm.$message && vm.$message.error('请选择不同的币种进行兑换')
                        vm.feeRate = null
                        vm.amountOut = null
                        vm.calculatedOut = ''
                        vm.networkFee = null
                        return
                    }
